import {
  Breadcrumb,
  Layout,
  Menu,
  Avatar,
  Button,
  Dropdown,
  Space,
  Input,
  Flex,
  Select,
  message,
  Popover,
} from "antd";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  DefaultAdminPage,
  DefaultUserPage,
  FormatUserName,
  thirdColor,
  Types,
} from "../../../config";
import { BackToAdminWrapper, MenuView, SearchDesign } from "./style";
import { Icon } from "@iconify/react/dist/iconify.js";
import { primaryColor } from "../../../config";
import { SearchOutlined } from "@ant-design/icons";
import { fakeImage } from "../../../config/fakeData";
import { AddBTN } from "../../../components/button";
import { ProfileView } from "../header/style";
import { MakeApiCall } from "../../../apis";
import LanguageSwitcher from "../../../components/LanguageSwitcher";
import { resolveMediaUrl } from "../../../utils/mediaUrl";
import { canAccess } from "../../../utils/permissions";
import {
  DEFAULT_MARKETPLACE_ICON,
  resolveMarketplaceIcon,
} from "../../../utils/marketplaceIcons";
const { Header } = Layout;
const findRoutes = {
  admin: DefaultAdminPage,
  user: DefaultUserPage,
};

const { Search } = Input;

const MarketPlaceImage = {
  "Amazon.com": "/assets/amz.png",
  "Amazon.co.uk": "/assets/amz.png",
  "Amazon.ca": "/assets/amz.png",
  "Amazon.sa": "/assets/amz.png",
  "Walmart.com":
    "https://www.pngall.com/wp-content/uploads/12/Walmart-Logo-PNG-Image.png",
};

export default function HeaderView({
  user,
  setData,
  location,
  collapsed,
  setCollapsed,
  handleLogout,
  visible,
  setVisible,
  handleCollapsed,
  isSmallScreen,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { email, name } = user?.user?.user_data;

  // Pages where marketplace dropdown should be hidden
  const hideMarketplaceDropdownPages = [
    '/dashboard',
    '/categories',
    '/brands',
    '/products',
    '/products/add',
    '/products/publish',
    '/manual-upload',
    '/catalog',
    '/catalogs',
    '/order-reports',
    'sales-reports',
    'returns-reports',
    '/settings',
    '/callback-sp',
    '/callback-ads',
    '/callback-salla',
    '/callback-zid',
    '/noon',
    '/trendyol',
    '/app-management',
    '/subscription',
    '/order-summary',
    '/all-orders',
    '/imported-reports',
    'exports',
    '/roles',
    '/user-management',
    '/my-profile',
    '/account',
    '/ads-performance',
    '/inventory',
    '/sku-perfomance',
  ];

  const shouldHideMarketplaceDropdown = hideMarketplaceDropdownPages.some(
    (path) => location?.pathname?.includes(path)
  );

  const [selectedMarketPlaceId, setSelectedMarketPlaceId] = useState(
    user?.marketplace_id || null
  );
  const [marketPlaceListLoading, setMarketPlaceListLoading] = useState(false);
  const [marketPlaceList, setMarketPlacelist] = useState([]);
  const [selectSellerType, setSelectSellerType] = useState(
    user?.seller_type || null
  );
  const [selectedSource, setSelecteSource] = useState(
    "Amazon" || user?.source || null
  );

  const [sourceListLoading, setSourceListLoading] = useState(false);
  const [sourceList, setSourceList] = useState([]);

  const [sellerPopoverVisible, setSellerPopoverVisible] = useState(false);
  const [sourcePopoverVisible, setSourcePopoverVisible] = useState(false);

  const menu = (
    <MenuView>
      <Menu className="custom-dropdown-menu">
        <div className="profile-header">
          {user?.user?.user_data?.photo ? (
            <Avatar
              style={{
                width: 50,
                height: 50,
              }}
              size={isSmallScreen ? 28 : 54}
              src={user?.user?.user_data?.photo ? resolveMediaUrl(user?.user?.user_data?.photo) : undefined}
            />
          ) : (
            <Avatar
              style={{
                backgroundColor: "#073b4c",
                verticalAlign: "middle",
                fontSize: isSmallScreen ? "16px" : "18px",
              }}
              size={isSmallScreen ? "default" : "large"}
            >
              {user?.user?.user_data?.name?.charAt(0).toUpperCase()}
            </Avatar>
          )}
          <div className="profile-info">
            <h4 style={{ fontWeight: "700" }}>{user?.user?.user_data?.name}</h4>
            <p>{user?.user?.user_data?.email}</p>
          </div>
        </div>
        <Menu.Divider />
        {user?.loginType === "user" && (
          <>
            <Menu.Item className="py-3 ps-5 fw-semibold">
              <Link to="/my-profile" key="profile">
                {t('header.myProfile', 'My Profile')}
              </Link>
            </Menu.Item>
            {canAccess(user, "account.view") && (
              <Menu.Item className="py-3 ps-5 fw-semibold">
                <Link to="/account" key="account">
                  {t("header.account", "My Account")}
                </Link>
              </Menu.Item>
            )}

            <Menu.Divider />
          </>
        )}

        <Menu.Item key="signout">
          <Button
            type="text"
            onClick={handleLogout}
            style={{ background: "#000", color: "#fff", height: "40px" }}
            block
          >
            {t('header.signOut', 'Sign Out')}
          </Button>
        </Menu.Item>
      </Menu>
    </MenuView>
  );

  useEffect(() => {
    if (user?.loginType === "user") {
      // getMarketPlaceList();
      getSourceList();
    }
  }, [user?.loginType]);

  const getMarketPlaceList = async () => {
    setMarketPlaceListLoading(true);
    const response = await MakeApiCall(
      `marketplaces/get-marketplace-by-credential`,
      "get",
      null,
      true,
      {},
      user?.user?.auth_token
    );

    if (response.status === true) {
      const data = response?.data?.marketplace_list.map((item) => {
        return {
          label: (
            <div style={{ display: "flex", alignItems: "center" }}>
              <img
                src={MarketPlaceImage[item.sales_channel]}
                alt="Amazon"
                style={{ width: 20, height: 20, marginInlineEnd: 8 }}
              />
              {item.sales_channel}
            </div>
          ),
          value: item.marketplace_id,
        };
      });

      if (data?.length > 0) {
        const obj = {
          ...user,
          // marketplace_id: data[0].value,
          currency_sign: response?.data?.currency_symbols?.[data[0].value],
        };
        setSelectedMarketPlaceId(data[0].value);
        setData(obj);
      }

      setMarketPlacelist(data);
      setMarketPlaceListLoading(false);
    } else {
      setMarketPlaceListLoading(false);
      message.error(response.message);
    }
  };

  const getSourceList = async () => {
    setSourceListLoading(true);
    const response = await MakeApiCall(
      `marketplaces/get-source-list`,
      "get",
      null,
      true,
      {},
      user?.user?.auth_token
    );

    if (response.status === true) {
      const data = response?.data?.source_list.map((item) => {
        const iconSrc =
          resolveMarketplaceIcon(item.source || item.name, {
            [String(item.source || '').toLowerCase()]: item.logo,
            [String(item.name || '').toLowerCase()]: item.logo,
          }, {
            name: item.name,
            logo_url: item.logo,
          }) || DEFAULT_MARKETPLACE_ICON;

        return {
          label: (
            <div style={{ display: "flex", alignItems: "center" }}>
              <img
                src={iconSrc}
                alt={item.source}
                style={{ width: 20, height: 20, marginInlineEnd: 8 }}
              />
              {item.source}
            </div>
          ),
          value: item.source.charAt(0).toLowerCase() + item.source.slice(1),
        };
      });

      if (data?.length > 0) {
        const obj = {
          ...user,
          source: user?.source || data[0].value,
          currency_sign: "﷼",
        };
        setSelecteSource(data[0].value);
        setData(obj);
      }

      setSourceList(data);
      setSourceListLoading(false);
    } else {
      setSourceListLoading(false);
      message.error(response.message);
    }
  };

  // Seller type popover content
  const sellerTypeContent = (
    <Select
      value={user?.seller_type}
      placeholder={t('header.selectSeller', 'Select Seller')}
      onChange={(value) => {
        const obj = { ...user, seller_type: value };
        setData(obj);
        setSellerPopoverVisible(false);
      }}
      options={[
        { label: t('header.seller', 'Seller'), value: "seller" },
        { label: t('header.vendor', 'Vendor'), value: "vendor" },
      ]}
      style={{ width: 150 }}
      size="large"
    />
  );

  // Source popover content
  const sourceContent = (
    <Select
      mode="multiple"
      placeholder={t('header.selectSource', 'Select Source')}
      value={user?.source}
      onChange={(value) => {
        const obj = { ...user, source: value };
        setData(obj);
        setSourcePopoverVisible(false);
      }}
      options={sourceList}
      loading={sourceListLoading}
      style={{ width: 200 }}
      size="large"
    />
  );
  return (
    <Header
      className="slideInDown"
      style={{
        padding: "0px 10px 0px 0px",
        background: "rgb(255 255 255)",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: "0px",
        borderRadius: "0px",
        marginInlineEnd: "0px",
        position: "sticky",
        top: 0,
        zIndex: 9,
        transition: "box-shadow .25s ease-in,background-color .25s ease-in",
        backdropFilter: "saturate(87%) blur(20px)",
        minHeight: "75px",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: isSmallScreen ? "20px" : "80px",
        }}
      >
        <div className="d-flex align-items-center">
          <div
            style={{
              background: "#1c1c1c",
              margin: "auto",
              height: isSmallScreen ? "35px" : "40px",
              width: isSmallScreen ? "35px" : "40px",
              marginInlineStart: "20px",
              borderRadius: "8px",
              transform: collapsed ? "rotate(180deg)" : "rotate(0deg)",
              border: `1px solid rgb(50 50 50)`,
            }}
            onClick={() => {
              if (isSmallScreen) {
                setCollapsed(false);
                setVisible(!visible);
              } else {
                setCollapsed(!collapsed);
              }
            }}
            className="d-flex align-items-center justify-content-center"
          >
            <Icon
              icon="ri:align-right"
              width={isSmallScreen ? 20 : 23}
              style={{ color: "#fff" }}
            />
          </div>

          <div className="">
            <img
              style={{
                marginInlineStart: isSmallScreen ? "10px" : "20px",
                height: isSmallScreen ? "30px" : "35px",
              }}
              alt="Logo"
              src={"/assets/loops-logo1.png"}
            />
          </div>
        </div>
      </div>

      <div className="d-flex align-items-center" style={{ gap: 16 }}>
        {user?.loginType === "user" && (
          <div
            className="d-flex align-items-center"
            style={{
              height: "70px",
              gap: 16,
            }}
          >
            {!shouldHideMarketplaceDropdown && (
              isSmallScreen ? (
                <Popover
                  content={sourceContent}
                  title={t('header.selectSource', 'Select Source')}
                  trigger="click"
                  visible={sourcePopoverVisible}
                  onVisibleChange={setSourcePopoverVisible}
                >
                  <div className="d-flex align-items-center justify-content-center">
                    <Icon icon="solar:tag-price-outline" width={22} />
                  </div>
                </Popover>
              ) : (
                <Select
                  mode="multiple"
                  placeholder={t('header.selectSource', 'Select Source')}
                  value={user?.source}
                  onChange={(value) => {
                    const obj = { ...user, source: value };
                    setData(obj);
                  }}
                  options={sourceList}
                  loading={sourceListLoading}
                  style={{ width: 250 }}
                  size="large"
                />
              )
            )}
            {user?.admin && (
              <BackToAdminWrapper
                onClick={() => {
                  setData(user?.admin);
                  navigate(findRoutes?.[user?.admin?.loginType]);
                }}
                className="ms-3"
              >
                <Icon icon="solar:logout-2-outline" width={22}></Icon>
                {t('header.backToAdmin', 'Back to Admin')}
              </BackToAdminWrapper>
            )}
          </div>
        )}

        {/* <div className={isSmallScreen ? "ms-2" : "ms-3"}>
          <div style={{ display: "flex" }}>
            <Icon
              icon="solar:settings-outline"
              width={isSmallScreen ? 20 : 24}
              style={{ color: "#000" }}
            />
          </div>
        </div>
        <div className={isSmallScreen ? "ms-3" : "ms-5"}>
          <div style={{ display: "flex" }}>
            <Icon
              icon="solar:bell-linear"
              width={isSmallScreen ? 20 : 24}
              style={{ color: "#000" }}
            />
          </div>
        </div> */}

        {/* Language Switcher */}
        <div className={isSmallScreen ? "ms-0" : "ms-3"}>
          <LanguageSwitcher />
        </div>

        <div className={isSmallScreen ? "ms-0" : "ms-3"}>
          <div className="d-flex align-items-center justify-content-center">
            <Dropdown
              trigger={["hover"]}
              overlay={menu}
              placement="bottomRight"
            >
              <Flex className="" align="center">
                {user?.user?.user_data?.photo ? (
                  <Avatar
                    size={isSmallScreen ? 35 : 45}
                    src={user?.user?.user_data?.photo ? resolveMediaUrl(user?.user?.user_data?.photo) : undefined}
                  />
                ) : (
                  <Avatar
                    style={{
                      backgroundColor: "#073b4c",
                      verticalAlign: "middle",
                      fontSize: isSmallScreen ? "16px" : "18px",
                    }}
                    size={isSmallScreen ? "default" : "large"}
                  >
                    {user?.user?.user_data?.name?.charAt(0).toUpperCase()}
                  </Avatar>
                )}
              </Flex>
            </Dropdown>
          </div>
        </div>
      </div>
    </Header>
  );
}
